import React from "react";
import MantineTextInput from "../../components/mantine/textinput"
import { useForm } from '@mantine/form';
import { Flex, Stack } from "@mantine/core";
import MantineButton from "../../components/mantine/button";
import MantinePasswordInput from "../../components/mantine/passwordinput";
import { changepwd } from "../../store/actions"
import { PlaceholderUi, hasCapitalLetter, hasMinimumLength, hasNoStartingNumber, hasNumber, hasSpecialCharacter, validateConfirmPassword, validateUserName, validateNewPassword } from "../../helpers/common";
import PasswordValidation from "../../components/common/passwordValidation";

const ResetPasswordForm = (props: any) => {
    const { userData, modalclose, dispatch, setpasswordVal, passwordVal, handleResponsepassword, currentPrimaryColor } = props // props parents to child call 
    const form = useForm({
        initialValues: {
            email: userData?.email,
            username: userData?.userName,
            password: '',
            confirmPassword: ''
        },
        validate: {
            username: (val: any) => (validateUserName(val)),
            password: (val) => validateNewPassword(val, passwordVal),
            confirmPassword: (value, values) => (validateConfirmPassword(value, values.password)),
        }
    });
    const ispasswordCondition = form.values.password;
    const Changepassworduser = () => { // api triggered in call password change
        if (hasMinimumLength(ispasswordCondition) && hasNumber(ispasswordCondition) && hasSpecialCharacter(ispasswordCondition) && hasCapitalLetter(ispasswordCondition) && hasNoStartingNumber(ispasswordCondition)) setpasswordVal(true);
        else setpasswordVal(false);
        form.validate();
        if (form.isValid()) {
            const data = {
                "userName":form.values.username,
                "password": form.values.confirmPassword.toString()
            }
            dispatch(changepwd(data, handleResponsepassword));
        }
    }

    return (
        <>
            <form onSubmit={form.onSubmit(() => { })}>
                <Stack>
                    <MantineTextInput
                        {...form.getInputProps('email')}
                        required
                        label="Email"
                        placeholder="Enter Your Email"
                        disabled={true}
                        value={form.values.email}
                        onChange={(event: any) => form.setFieldValue('email', event.currentTarget.value)}
                        classNames={{ input: `${PlaceholderUi}`, label: "text-sm" }}
                    />
                    <MantineTextInput
                        {...form.getInputProps('username')}
                        label="UserName"
                        placeholder="Enter Your UserName"
                        disabled={true}
                        value={form.values.username}
                        onChange={(event: any) => form.setFieldValue('username', event.currentTarget?.value)}
                        classNames={{ input: `${PlaceholderUi}`, label: "text-sm" }}
                    />
                    <MantinePasswordInput
                        {...form.getInputProps('password')}                       
                        label="New Password"
                        placeholder="Enter Your New Password"
                        value={form.values.password}
                        onChange={(event: any) => form.setFieldValue('password', event.currentTarget?.value)}
                        classNames={{ innerInput: `placeholder-input_placeholder`, input: `${PlaceholderUi}`, label: "text-sm" }}
                    />
                    <PasswordValidation ispasswordCondition={ispasswordCondition} className={"px-1"}/>
                    <MantinePasswordInput
                        {...form.getInputProps('confirmPassword')}
                        label="Confirm Password"
                        placeholder="Enter Your Confirm Password"
                        value={form.values.confirmPassword}
                        onChange={(event: any) => form.setFieldValue('confirmPassword', event.currentTarget.value)}
                        classNames={{ innerInput: `placeholder-input_placeholder`, input: `${PlaceholderUi}`, label: "text-sm" }}
                    />
                    <Flex justify="flex-end">
                        <MantineButton name={'Save'} className={" mt-[15px] text-sm font-thin !w-[90px] mr-3"} onClick={() => Changepassworduser()} color={currentPrimaryColor} />
                        <MantineButton name={'Cancel'} className={"bg-secondary_color hover:bg-hover_secondary_btn mt-[15px] text-sm font-thin !w-[100px]"} onClick={modalclose} />
                    </Flex>
                </Stack>
            </form >
        </>
    )
}
export default ResetPasswordForm;